<template>
  <q-badge
    class="q-px-sm q-py-xxs radius-8"
    :color="badge(type).color"
    :text-color="badge(type).textColor"
  />
</template>

<script setup>
defineProps({
  type: {
    type: String,
    default: "Primary",
  },
});

const badge = useColor();
</script>
